import React from 'react';

/**
 * Button Component
 * Универсальная кнопка с тремя вариантами оформления
 * 
 * @param {string} variant - 'primary' (синяя), 'secondary' (серая) или 'outline' (с обводкой)
 * @param {string} children - Текст кнопки
 * @param {function} onClick - Обработчик клика
 * @param {string} className - Дополнительные CSS классы
 */
export const Button = ({ 
  variant = 'primary', 
  children, 
  onClick, 
  className = '',
  type = 'button',
  ...props 
}) => {
  const baseStyles = `
    h-9 px-4
    rounded-lg 
    font-medium text-[15px] leading-5 
    text-center 
    transition-all duration-200 
    cursor-pointer
    inline-flex items-center justify-center
    disabled:opacity-50 disabled:cursor-not-allowed
  `;

  const variants = {
    primary: `
      bg-[#0077ff] 
      text-white
      hover:bg-[#0066dd] 
      active:bg-[#0055bb]
    `,
    secondary: `
      bg-[rgba(0,16,61,0.06)]
      text-[#2c2d2e]
      hover:bg-[rgba(0,16,61,0.1)] 
      active:bg-[rgba(0,16,61,0.15)]
    `,
    outline: `
      border border-white 
      bg-transparent 
      text-white
      hover:bg-white/10 
      active:bg-white/20
    `
  };

  return (
    <button
      type={type}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;